export default __webpack_public_path__ + "static/media/Figtree-Medium.9f5bdeaa.ttf";